import classnames from 'classnames';
import Shimmer from '../../Shimmer';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { ScreenSizeQueries } from '@/constants/breakpoints';

interface CartItemsShimmerProps {
  isPageContext: boolean;
}

const CartItemsShimmer = ({ isPageContext }: CartItemsShimmerProps) => {
  const md = useMediaQuery(ScreenSizeQueries.md);
  const cartLineItemsStyles = (index: number) =>
    classnames('max-w-full border-t border-solid border-gray-light py-6', {
      'border-t-0': isPageContext && index === 0
    });

  return (
    <>
      {Array.from({ length: 5 }).map((_, i) => (
        <div className={cartLineItemsStyles(i)} key={`shimmer-${i}`}>
          <div className="mb-4">
            <Shimmer className="h-4 w-24" />
          </div>
          <div className="mb-4 flex">
            <div className="flex w-[70%] flex-col gap-1">
              <Shimmer className="h-5 w-full" />
              <Shimmer className="h-5 w-64" />
            </div>
            <div className="w-[10%]"></div>
            <div className="flex w-1/5 flex-col items-end text-right">
              <div
                className={`flex items-end gap-1 ${isPageContext && md ? 'flex-row' : 'flex-col-reverse'}`}
              >
                <Shimmer className="h-5 w-14" />
                <Shimmer className="h-5 w-16" />
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <Shimmer className="h-5 w-8" />
            <Shimmer className="h-5 w-6 rounded" />
          </div>
        </div>
      ))}
    </>
  );
};

export default CartItemsShimmer;
